import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

import { type ClockLocationInput, clockOut } from "@/adapters/api";
import { useActiveContext } from "@/store/use-active-context";
import { NO_LOCATION_MESSAGE, timeEntryErrorMessage } from "../utils/format";
import { invalidateAttendance } from "./invalidate-attendance";

export function useClockOut() {
	const queryClient = useQueryClient();
	const activeCanteiroId = useActiveContext((state) => state.activeCanteiroId);

	return useMutation({
		mutationFn: (location: ClockLocationInput | null) =>
			clockOut(activeCanteiroId as string, location),
		onSuccess: (_entry, location) => {
			invalidateAttendance(queryClient);
			toast.success("Saída registrada", {
				description: location ? undefined : NO_LOCATION_MESSAGE,
			});
		},
		onError: (err) => {
			toast.error(
				timeEntryErrorMessage(err, "Não foi possível registrar a saída."),
			);
		},
	});
}
